import { z } from 'zod'
import { apiClient } from '@/lib/api/client.ts'

/**
 * What this instance is (law-c8ee3d8). The one wire shape the settings feature
 * owns: the engine answers `GET /api/instance` with the tenant it serves and
 * the image tag it is running.
 *
 * `version` is whatever the engine reports and is rendered verbatim — never
 * prettified, never compared against the console's own build. A console bundle
 * and the engine serving it come from one image here, but the value's job is to
 * say what is deployed, and a display that "corrected" it would defeat that.
 */
export const instanceSchema = z.object({
  tenant: z.string(),
  version: z.string(),
  publicUrl: z.string().nullable(),
  scheduler: z.string().nullable(),
})

export type Instance = z.infer<typeof instanceSchema>

export async function fetchInstance(): Promise<Instance> {
  const { data } = await apiClient.get('/instance')
  return instanceSchema.parse(data)
}
